import { useSelector } from 'react-redux';

import { selectIsAiEnabled, selectIsFirstPriorityUser } from '../selectors/chat';

export const useIsFirstPriorityExperience = () => {
  const isAiEnabled = useSelector(selectIsAiEnabled);
  const isFirstPriority = useSelector(selectIsFirstPriorityUser);
  return isAiEnabled && isFirstPriority;
};
